module.exports = __webpack_public_path__ + "/content/skins/pcna/fonts/porsche-next-web-latin/porsche-next-w-la-thin.woff2";